module.exports = __webpack_public_path__ + "1346450b268d5b5d644891a73ecc9772.pdf";